<template>
    <div class="body" :class="{ overlay: allScreen, compact: compact }">
        <div class="loader-container">
            <div class="loader-stage">
                <div class="loader">
                    <div class="corners">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div class="box">
                        <p>P</p>
                    </div>
                </div>
            </div>
            <div v-if="showWelcomeText" class="welcome-text">
              {{ welcomeText }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "PageLoader",
  props: {
    allScreen: {
      type: Boolean,
      default: false
    },
    showWelcomeText: {
      type: Boolean,
      default: false
    },
    welcomeText: {
      type: String,
      default: "PecSmart"
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.body {
  top: 0;
  left: 0;
  background-color: #f2f2f2;
  z-index: 999;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body.compact {
  min-height: 120px;
  background-color: transparent;
  z-index: 1;
}

.body.compact .loader-stage {
  width: 80px;
  height: 80px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo opaco */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.loader {
  z-index: 999;
  position: relative;
  width:60px;
  height:60px;
  animation:scaling 2.5s ease infinite;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader-stage {
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-text {
  font-size: 20px;
  color: #78b843;
  font-weight: 500;
  text-align: center;
  opacity: 0.9;
  animation: fadePulse 1.8s ease-in-out infinite;
  margin-top: 12px;
  position: relative;
  z-index: 1;
}
.loader .corners {
  position:absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  animation:loading 2.5s ease infinite;
}
.loader .corners span {
  position:absolute;
  width:20px;
  height:20px;
}
.loader .corners span:nth-child(1) {
  top:0px;
  left:0px;
  border-top:3px solid #78b843;
  border-left:3px solid #78b843;
}
.loader .corners span:nth-child(2) {
  top:0px;
  right:0px;
  border-top:3px solid #78b843;
  border-right:3px solid #78b843;
}
.loader .corners span:nth-child(3) {
  bottom:0px;
  right:0px;
  border-bottom:3px solid #78b843;
  border-right:3px solid #78b843;
}
.loader .corners span:nth-child(4) {
  bottom:0px;
  left:0px;
  border-bottom:3px solid #78b843;
  border-left:3px solid #78b843;
}
.loader .box {
  width:45px;
  height:45px;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
.loader .box p {
  margin-top: auto;
  color: #78b843;
  font-size: 40px;
  font-family: arial;
  position: absolute;
  top:-17%;
  left:25%;
}
@keyframes loading {
  50% {
    transform:rotate(135deg);
  }
  100% {
    transform:rotate(270deg);
  }
}
@keyframes scaling {
  0% {
    transform:scale(1.2);
  }
  50% {
    transform:scale(1.7);
  }
  100% {
    transform:scale(1.2);
  }
}

@keyframes fadePulse {
  0% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.45;
  }
}
</style>
